import { useEffect } from "react";

interface UseClampedPageCountParams {
    totalPages: number | undefined;
    page: number;
    setPage: (page: number) => void;
}

export function useClampedPageCount({
    totalPages,
    page,
    setPage,
}: UseClampedPageCountParams): number {
    const pageCount = Math.max(1, totalPages ?? 1);

    useEffect(() => {
        if (page > pageCount) {
            setPage(pageCount);
        }
    }, [page, pageCount, setPage]);

    return pageCount;
}
